import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "./Hub.module.css"

import Sidebar from '../Sidebar';
import IndEvent from './IndEvent';
import NewEvent from './NewEvent';
import Lockout from './Lockout';


const Banner = ({ handleOpen }) => {
	const navigate = useNavigate();
	const [showingLabel, setShowingLabel] = useState(true)
	const [search, setSearch] = useState("")
	const divRef = useRef(null);
	const [userData, setUserData] = useState({})
	const [searchResults, setSearchResults] = useState({
		events: [],
		guestiis: [],
		teamMembers: []
	})

	useEffect(() => {
		const handleLoad = async () => {
			try {
				const userId = localStorage.getItem("_id")
				const retrieve = await axios.get(`/api/hub/get-user-data/${userId}`);
				setUserData(retrieve.data.user)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}
		}

		handleLoad()
	}, []);


	const handleSearch = async (input) => {
		const userId = localStorage.getItem("_id")
		const searchTerm = input.target.value
		setSearch(searchTerm)

		if (searchTerm !== "") {
			const retrieve = await axios.get(`/api/hub/${userId}/search-all/${searchTerm}`);
			setSearchResults(retrieve.data.data)
		}
	}

	function formatDate(dateString) {
    const date = new Date(dateString);

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const day = days[date.getDay()];
    const dateNumber = date.getDate();
    const month = months[date.getMonth()];

    const suffix =
        dateNumber % 10 === 1 && dateNumber !== 11
            ? 'st'
            : dateNumber % 10 === 2 && dateNumber !== 12
            ? 'nd'
            : dateNumber % 10 === 3 && dateNumber !== 13
            ? 'rd'
            : 'th';

    return `${day}, ${dateNumber}${suffix} ${month}`;
	}

	function convertTo24HourTime(isoString) {
    const date = new Date(isoString);
    const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

    return time;
	}

	const handleClickOutside = (event) => {
  	if (divRef.current && !divRef.current.contains(event.target)) {
  		setSearch("")

			setSearchResults({
				events: [],
				guestiis: [],
				teamMembers: []
			})
  	}
	};

	const handleClickItem = (item, searchKey) => {
		const userId = localStorage.getItem("_id")

		switch (searchKey) {
			case 'events':
				handleOpen("event", item)
				break;
			case 'guestiis':
				var state = { from: item };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				navigate(`/guestiis/${userId}`)
				break;
			case 'teamMembers':
				var state = { from: item };
				sessionStorage.setItem('navigationState', JSON.stringify(state));

				navigate(`/team/${userId}`)
				break;
		}

	}

	useEffect(() => {
  	document.addEventListener('mousedown', handleClickOutside);

  	return () => {
    		document.removeEventListener('mousedown', handleClickOutside);
  	};
	}, []);

	return (
		<div className={styles.banner_container}>
			<div className={styles.banner_greeting}>
				<h3>Hi, {userData.first_name}</h3>
				<p>Welcome back to your Guestii hub!</p>
			</div>

			<div className={styles.banner_tools}>
				<div className={styles.nevent_input_container_search}>
					<div
						className={styles.movingLabelSearch}
	        	style={{
	          	top: showingLabel && !search ? "50%" : "-20px",
	          	transform: showingLabel && !search ? "translate(0, -50%)" : "",
	          	transition: "top 0.3s ease, left 0.3s ease, transform 0.3s ease, color 0.3s ease",
	          	color: !(showingLabel && !search) && "#01000D"
	        	}}
					>
						<i className={`fa-solid fa-magnifying-glass ${styles.m1}`}></i>
						<p className={`${styles.s1}`}>Search for anything</p>
					</div>

					<input
						type="text"
						className={styles.s1}
						onChange={(input) => handleSearch(input)}
						onFocus={() => setShowingLabel(false)}
						onBlur={() => setShowingLabel(true)}
						onClick={() => setShowingLabel(false)}
						value={search}
					/>
				</div>

				{search !== "" &&
					<>
						{Object.values(searchResults).length > 0 &&
							<div className={styles.search_outer_container} ref={divRef}>
								{Object.keys(searchResults).map((searchKey) => {
									let resultItem = searchResults[searchKey]

									return (
										<>
											{resultItem.map((item) => (
												<button className={styles.searchItem} onClick={() => handleClickItem(item, searchKey)}>
													<i className={`fa-solid fa-${searchKey === "events" ? "clipboard-check" : searchKey === "guestiis" ? "clipboard-user" : "users"} ${styles.m1}`}></i>

													{searchKey === "events"
														?
															<div className={styles.searchItemContent}>
																<p className={`${styles.s1}`}>{item.name}</p>
																<p className={`${styles.xs3}`}>{formatDate(item.start_date)} {convertTo24HourTime(item.start_date)} - {formatDate(item.end_date)} {convertTo24HourTime(item.end_date)}</p>
															</div>
														:
															<div className={styles.searchItemContent}>
																<p className={`${styles.s1}`}>{item.first_name} {item.last_name}</p>
																<p className={`${styles.xs3}`}>{item.email || item.phone}</p>
															</div>
													}
													
												</button>
											))}
										</>
									)
								})}
							</div>
						}
					</>
				}

				<button className={styles.profile_btn}><i className={`fa-solid fa-user ${styles.m1}`}></i></button>
			</div>
		</div>
	)
}

const EventWidget = ({ handleOpen, events, setEvents, isLoading, sortByDateTime, filterEventByDate, eventsOG, eventNav, setEventNav, activeDate, setActiveDate, isEventManager }) => {
	const navigate = useNavigate();


	useEffect(() => {
		setEvents(sortByDateTime([...events]))
	}, [events.length]);

	const handleOpenEvent = (eventId) => {
  	const userId = localStorage.getItem("_id")
  	navigate(`/hub/${userId}/${eventId}`)
	}


	function formatDate(dateString) {
    const date = new Date(dateString);

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const day = days[date.getDay()];
    const dateNumber = date.getDate();
    const month = months[date.getMonth()];

    const suffix =
        dateNumber % 10 === 1 && dateNumber !== 11
            ? 'st'
            : dateNumber % 10 === 2 && dateNumber !== 12
            ? 'nd'
            : dateNumber % 10 === 3 && dateNumber !== 13
            ? 'rd'
            : 'th';

    return `${day}, ${dateNumber}${suffix} ${month}`;
	}

	function convertTo24HourTime(isoString) {
    const date = new Date(isoString);
    const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

    return time;
	}

	function isDateWithinRange(startDateTime, endDateTime) {
    const now = new Date();
    const startDate = new Date(startDateTime);
    const endDate = new Date(endDateTime);

    return now >= startDate && now <= endDate;
	}

	function isDateUpcomingRange(startDateTime, endDateTime) {
    const now = new Date();
    const startDate = new Date(startDateTime);
    const endDate = new Date(endDateTime);

    return now <= startDate && now <= endDate;
	}

	function isDatePastRange(startDateTime, endDateTime) {
    const now = new Date();
    const startDate = new Date(startDateTime);
    const endDate = new Date(endDateTime);

    return now >= startDate && now >= endDate;
	}

	const handleEventNav = (nav) => {
		let eventsDup = [...eventsOG]

		switch (nav) {
			case 'All':
				filterEventByDate(new Date(), true)
				break;
			case 'Live':
				let liveEvents = eventsDup.filter(event => {
					let isLive = isDateWithinRange(event.start_date, event.end_date)

					return isLive
				})

				setEvents(liveEvents)
				break;
			case 'Upcoming':
				let upcomingEvents = eventsDup.filter(event => {
					let isUpcoming = isDateUpcomingRange(event.start_date, event.end_date)

					return isUpcoming
				})

				setEvents(upcomingEvents)
				break;
			case 'Past':
				let pastEvents = eventsDup.filter(event => {
					let isPast = isDatePastRange(event.start_date, event.end_date)

					return isPast
				})

				setEvents(pastEvents)
				break;
		}

		setEventNav(nav)
		setActiveDate(new Date())
	}


	return (
		<div className={`${styles.widget_container} ${styles.event_widget} ${styles.widget_container_extra}`}>
			<div className={styles.widget_banner}>
				<p>My Events</p>

				{(!isEventManager && !isLoading) &&
					<button className={styles.widget_action_container} onClick={() => handleOpen("new")}>
						<p className={`${styles.s2} ${styles.add_new}`}>Add New</p>
						<div className={styles.widget_action}><i class={`fa-solid fa-plus ${styles.m1}`}></i></div>
					</button>
				}
			</div>

			<div className={styles.event_nav}>
				<button
					className={`${styles.event_nav_btn} ${eventNav === "All" && styles.event_nav_btn_active}`}
					onClick={() => handleEventNav('All')}
				>
					<p className={styles.s1}>All</p>
				</button>
				<button
					className={`${styles.event_nav_btn} ${eventNav === "Live" && styles.event_nav_btn_active}`}
					onClick={() => handleEventNav('Live')}
				>
					<p className={styles.s1}>Live</p>
				</button>
				<button
					className={`${styles.event_nav_btn} ${eventNav === "Upcoming" && styles.event_nav_btn_active}`}
					onClick={() => handleEventNav('Upcoming')}
				>
					<p className={styles.s1}>Upcoming</p>
				</button>
				<button
					className={`${styles.event_nav_btn} ${eventNav === "Past" && styles.event_nav_btn_active}`}
					onClick={() => handleEventNav('Past')}
				>
					<p className={styles.s1}>Past</p>
				</button>
			</div>

			<div className={styles.outer_event_container}>
				<div className={styles.event_list}>

					{!isLoading
						?
							<>
								{events.length > 0
									?
										<>
											{events.map((event, index) => {
												let isLive = isDateWithinRange(event.start_date, event.end_date)
												let isCancelled = event.status === "Cancelled"

												return (
													<div className={styles.event_item}>
														<div className={styles.event_line}>
															{isLive
																?
																	<>
																		<div className={styles.line_circle_live}/>
																		{(index !== events.length - 1) && <div className={styles.line_live}/>}
																	</>
																:
																	<>
																		<div className={styles.line_circle}/>
																		{(index !== events.length - 1) && <div className={styles.line}/>}
																	</>
															}
														</div>
					
														<div className={styles.event_info_b}>
															<p>{formatDate(event.start_date)}</p>
															<p className={styles.s1}>{convertTo24HourTime(event.start_date)} - {convertTo24HourTime(event.end_date)}</p>
															{isLive && 
																<div className={styles.live_pointer_container}>
																	<div className={styles.live_dot}></div>
																	<p className={styles.xs3}>LIVE</p>
																</div>
															}
														</div>
					
														<button className={`${styles.event_content} ${isLive && styles.event_live} ${isCancelled && styles.cancelled_event}`} onClick={() => handleOpenEvent(event._id)}>
															<p>{event.name}</p>
															<p className={styles.s1}>{event.location.formatted_address}</p>
					
															<div className={styles.event_tools}>
																<div className={styles.tool_box}>
																	<i class={`fa-solid fa-envelope ${styles.s2}`}></i>
																	<p className={styles.s2}>{event.guestiis.length}</p>
																</div>

																<div className={styles.tool_box}>
																	<i class={`fa-solid fa-envelope-circle-check ${styles.s2}`}></i>
																	<p className={styles.s2}>0</p>
																</div>

																<div className={styles.tool_box}>
																	<i class={`fa-solid fa-users ${styles.s2}`}></i>
																	<p className={styles.s2}>{event.team.length}</p>
																</div>
															</div>
														</button>
													</div>
												)
											})}
										</>
									: <div className={styles.noResults}><p>Create your first event to start!</p></div>
								}
							</>
						:
							<>
								{Array.from({ length: 5 }).map((_, index) => (
									<div className={styles.event_item}>
										<div className={styles.event_line}>
											<div className={styles.line_circle}/>
											{index !== 4 && <div className={styles.line}/>}
										</div>

										<div className={styles.event_info_b}>
											<p>Fri, 4th Oct</p>
											<p className={styles.s1}>23:59 - 06:00</p>
										</div>

										<button className={`${styles.event_content}`}>
											<p style={{color: "#449dd1"}}>Loud-Contact - Ricardo Villalobos</p>
											<p style={{color: "#449dd1"}} className={styles.s1}>Carrer Nou de la Rambla - Barcelona, Spain</p>

											<div className={styles.event_tools}>
												<div className={styles.tool_box}>
													<i class={`fa-solid fa-envelope ${styles.s2}`} style={{color: "#449dd1"}}></i>
													<p className={styles.s2} style={{color: "#449dd1"}}>84</p>
												</div>

												<div className={styles.tool_box}>
													<i class={`fa-solid fa-envelope-circle-check ${styles.s2}`} style={{color: "#449dd1"}}></i>
													<p className={styles.s2} style={{color: "#449dd1"}}>72</p>
												</div>

												<div className={styles.tool_box}>
													<i class={`fa-solid fa-bell ${styles.s2}`} style={{color: "#449dd1"}}></i>
													<p className={styles.s2} style={{color: "#449dd1"}}>72</p>
												</div>
											</div>
										</button>
									</div>
								))}
							</>
					}

				</div>
			</div>
		</div>
	)
}

const CalendarWidget = ({ eventsOG, isLoading, filterEventByDate, eventNav, setEventNav, activeDate, setActiveDate }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isMonthDropdownOpen, setIsMonthDropdownOpen] = useState(false);

  const daysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
  const startDayOfMonth = (year, month) => (new Date(year, month, 1).getDay() + 6) % 7;

  const handleMonthChange = (month) => {
    setCurrentDate((prev) => new Date(prev.getFullYear(), month, 1));
    setIsMonthDropdownOpen(false);
  };

  const handleDatePress = (date, showAll=false) => {
  	setEventNav("")
		setActiveDate(date);
		filterEventByDate(date, showAll)
  }

  const renderDays = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const days = daysInMonth(year, month);
    const startDay = startDayOfMonth(year, month);
    const today = new Date();

    const grid = [];
    for (let i = 0; i < startDay; i++) {
      grid.push(<div key={`empty-${i}`} className={styles.calendar_item} />);
    }

    for (let i = 1; i <= days; i++) {
      const date = new Date(year, month, i);
      const isToday = date.toDateString() === today.toDateString();
      const isActive = date.toDateString() === activeDate.toDateString();
      const hasEvent = eventsOG.some(
        (event) => new Date(event.start_date).toDateString() === date.toDateString()
      );

      grid.push(
        <button
          key={`day-${i}`}
          className={`${styles.calendar_item} ${
            isActive ? styles.active_calendar_item : ""
          }`}
          onClick={() => handleDatePress(date)}
        >
          <p className={styles.s2}>{i}</p>
          {hasEvent && <div className={styles.event_dot} />}
        </button>
      );
    }

    return grid;
  };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <div className={`${styles.widget_container} ${styles.calendar_widget}`}>
      <div className={styles.widget_banner}>
      	<div className={styles.event_calendar_header}>
        	<p>Event Calendar</p>
        </div>

        <button
          className={`${styles.widget_action_container} ${styles.widget_calendar}`}
          onClick={() => setIsMonthDropdownOpen((prev) => !prev)}
        >
          <p className={styles.s2}>
            {months[currentDate.getMonth()]} {currentDate.getFullYear()}
          </p>
          <i className={`fa-solid fa-chevron-down ${styles.xs1}`} />
        </button>

        {isMonthDropdownOpen && (
          <div className={styles.month_dropdown}>
            {months.map((month, index) => (
              <button
                key={month}
                className={`${styles.month_item} ${
                  currentDate.getMonth() === index ? styles.active_month : ""
                }`}
                onClick={() => handleMonthChange(index)}
              >
                <p className={`${styles.s3} ${styles.bold}`}>{month}</p>
              </button>
            ))}
          </div>
        )}
      </div>

      <div className={styles.calendar_outer_grid}>
        <div className={styles.calendar_grid}>
          {["M", "T", "W", "T", "F", "S", "S"].map((d, dindex) => (
            <div key={`day-header-${dindex}`} className={styles.calendar_item}>
              <p className={`${styles.s1} ${styles.bold}`}>{d}</p>
            </div>
          ))}
          {renderDays()}
        </div>
      </div>
    </div>
  )
}

const TeamsCarousel = ({ teamMembers, autoRotate=true, rotateInterval=10000 }) => {
	const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const timeoutRef = useRef(null);


  useEffect(() => {
    if (autoRotate) {
      startRotation();
      return () => stopRotation();
    }
  }, [currentSlide, autoRotate]);

  const startRotation = () => {
    stopRotation();
    timeoutRef.current = setTimeout(() => {
      handleNext();
    }, rotateInterval);
  };

  const stopRotation = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  const handleNext = () => {
    stopRotation();
    setCurrentSlide((prev) => (prev + 1) % Object.keys(teamMembers).length);
  };

  const handlePrev = () => {
    stopRotation();
    setCurrentSlide((prev) => (prev === 0 ? Object.keys(teamMembers).length - 1 : prev - 1));
  };

  const navigateTeam = (e) => {
  	if (e.target.localName !== "i") {
	  	const userId = localStorage.getItem("_id")
	  	navigate(`/team/${userId}`)
  	}
  }

	return (
  	<button className={styles.spare_widget} onClick={(e) => navigateTeam(e)}>
	    <div className={styles.carousel_wrapper}>
	      <button className={`${styles.carousel_nav_button} ${styles.carousel_nav_left}`} onClick={handlePrev}>
	        <i className="fa-solid fa-chevron-left" />
	      </button>

	      <div className={styles.carousel_container}>
	        {Object.keys(teamMembers).map((role, index) => {
	        	let empty = teamMembers[role].length === 0
	          let position = styles.nextSlide;
	          if (index === currentSlide) position = styles.activeSlide;
	          if (index === currentSlide - 1 || (currentSlide === 0 && index === Object.keys(teamMembers).length - 1)) {
	            position = styles.lastSlide;
	          }

	          let templateColumns = '1fr'
	          switch (teamMembers[role].length) {
	          	case 1:
	          		templateColumns = '1fr'
	          		break;
	          	case 2:
	          		templateColumns = '1fr 1fr'
	          		break;
	          	case 3:
	          		templateColumns = '1fr auto 1fr'
	          		break;
	          }


	          return (
	            <div key={`slide-${index}`} className={`${styles.slide} ${position}`}>
	              <div className={`${styles.slide_content} ${styles.slide_seperation}`}>
									<p className={styles.s3}>{role}s</p>

									{empty
										?
											<div className={styles.teamMemberGroup} style={{ gridTemplateColumns: '1fr' }}>
			              		<div className={styles.teamMemberInner}>
			              			<div className={styles.teamMemberMiddleCircle}>
			              				<i className={`fa-solid fa-${role === "Scanner" ? "qrcode" : role === "Event Manager" ? "clipboard-list" : "users"}`} />
			              			</div>
			              			<p className={styles.s1}>Create your first {role}</p>
			              		</div>
											</div>
										:
		            			<div className={styles.teamMemberGroup} style={{ gridTemplateColumns: templateColumns }}>
				              	{teamMembers[role].map((member, index) => {
				              		let isMiddle = false;

				              		if (teamMembers[role].length === 3) {
				              			isMiddle = true
				              		}

				              		return (
					              		<div className={styles.teamMemberInner}>
					              			<div className={(isMiddle && index === 1) ? styles.teamMemberMiddleCircle : styles.teamMemberCircle}>
					              				<i className={`fa-solid fa-${role === "Scanner" ? "qrcode" : role === "Event Manager" ? "clipboard-list" : "users"}`} />
					              			</div>
					              			<p className={styles.s1}>{member.first_name} {member.last_name}</p>
					              		</div>
				              		)
				              	})}
			              	</div>
									}
	              </div>
	            </div>
	          );
	        })}
	      </div>

	      <button className={`${styles.carousel_nav_button} ${styles.carousel_nav_right}`} onClick={handleNext}>
	        <i className="fa-solid fa-chevron-right" />
	      </button>

	    </div>
    </button>
	)
}


const HubPage = ({ handleOpen, events, setEvents, isLoading, filterEventByDate, sortByDateTime, eventsOG, eventNav, setEventNav, activeDate, setActiveDate, teamMembers, userData, isEventManager }) => {
	const current = "Hub"

	return (
		<div className={`${styles.container_outer} ${styles.fadeContainer}`}>
			<div className={styles.container}>
				<Sidebar { ... { current } }/>

				<div className={styles.content_container}>
					<Banner { ... { handleOpen, userData } }/>

					<div className={styles.hub_layout}>
						<EventWidget {... { handleOpen, events, setEvents, isLoading, sortByDateTime, filterEventByDate, eventsOG, eventNav, setEventNav, activeDate, setActiveDate, isEventManager } }/>

						<div className={styles.hub_secondary_layout}>
							<CalendarWidget { ... { eventsOG, isLoading, filterEventByDate, eventNav, setEventNav, activeDate, setActiveDate } }/>
							<TeamsCarousel { ... { teamMembers } }/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const Hub = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [isAuthenticated, setIsAuthenticated] = useState(true);
	const [indEvent, setIndEvent] = useState(null)
	const [eventsOG, setEventsOG] = useState([])
	const [events, setEvents] = useState([])
	const [isOpen, setIsOpen] = useState(null)
	const [eventNav, setEventNav] = useState("All")
	const [activeDate, setActiveDate] = useState(new Date());
	const [isEventManager, setIsEventManager] = useState(false)
	const [teamMembers, setTeamMembers] = useState({
		'Scanner': [],
		'SuperAdmin': [],
		'Event Manager': [],
	})
	const [tempFormData, setTempFormData] = useState(null)


	useEffect(() => {
	  const bootstrap = async () => {
	    setIsLoading(true);

	    try {
	      await Promise.all([
	        handleLoad(),
	        // handleTeamMembers(),
	        checkForNavigate()
	      ]);
	    } catch (err) {
	      console.error(err);
	    } finally {
	      setIsLoading(false);
	    }
	  }

  	bootstrap();
	}, []);

	const handleLoad = async () => {
		// expiry
		const userId = localStorage.getItem("_id")
		const expiry = localStorage.getItem("expiry")
		if (!userId || !expiry) {
			locationStorage.removeItem("_id")
			locationStorage.removeItem("expiry")
			window.location = "/connect"
		}

		try {
			const retrieve = await axios.get(`/api/hub/get-events/${userId}/${expiry}`);
			setEvents(retrieve.data.events)
			setEventsOG(retrieve.data.events)
			setIsEventManager(!retrieve.data.isSuperAdmin)
		} catch (e) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
		}
	}

	const handleTeamMembers = async () => {
		const userId = localStorage.getItem("_id")
		const expiry = localStorage.getItem("expiry")
		if (!userId || !expiry) {
			locationStorage.removeItem("_id")
			locationStorage.removeItem("expiry")
			window.location = "/connect"
		}

		try {
			const retrieve = await axios.get(`/api/team/get-team-members/${userId}/${expiry}`);
			let allTeams = retrieve.data.teamMembers

			let teamsLimited = {
				'Scanner': [],
				'SuperAdmin': [],
				'Event Manager': []
			}
			Object.keys(allTeams).map(team => teamsLimited[team] = allTeams[team].splice(0, 3))
			setTeamMembers(teamsLimited)

		} catch (e) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
		}
	}

	const checkForNavigate = () => {
		const fromState = JSON.parse(sessionStorage.getItem('navigationState'));

		if (fromState) {
			setIndEvent(fromState.from)
			setIsOpen("event")
			sessionStorage.removeItem('navigationState');
		}
	}

	function handleOpen(target, event?) {
		if (target === "close") {
			setIsOpen(null)
			setIndEvent(null)
			setTempFormData({})
		} else if (target === "edit") {
			setIsOpen("new")
			setTempFormData({
				...event,
				edit: true
			})
		} else if (target === "lockout") {
			setIsOpen("lockout")
			setTempFormData(event)
		} else {
			setIndEvent(event)
			setIsOpen(target)
		}
	}

	function sortByDateTime(events) {
    const now = new Date();

    const liveEvents = events.filter(event => new Date(event.start_date) <= now && new Date(event.end_date) >= now);
    const otherEvents = events.filter(event => new Date(event.start_date) > now || new Date(event.end_date) < now);

    liveEvents.sort((a, b) => 
      new Date(a.start_date) - new Date(b.start_date) ||
      new Date(a.end_date) - new Date(b.end_date)
    );

    otherEvents.sort((a, b) => 
      new Date(a.start_date) - new Date(b.start_date) ||
      new Date(a.end_date) - new Date(b.end_date)
    );

    return [...liveEvents.reverse(), ...otherEvents.reverse()];
	}

	const filterEventByDate = (date, showAll=false) => {
		if (showAll) {
			setEvents(sortByDateTime([...eventsOG]))
		} else {
	    const eventsForDate = eventsOG.filter(
	      (event) => new Date(event.start_date).toDateString() === date.toDateString()
	    );

	    setEvents(eventsForDate)
		}
	}

	return (
		// <HubPage {... { handleOpen, events, setEvents, isLoading, filterEventByDate, sortByDateTime, eventsOG, eventNav, setEventNav, activeDate, setActiveDate, teamMembers, isEventManager } }/>
		<div className={`${styles.overlay} ${(isOpen) && styles.white_overlay}`}>
			<div className={`${(isOpen) && styles.hidden_container} ${styles.fadeContainer}`}>
				<HubPage {... { handleOpen, events, setEvents, isLoading, filterEventByDate, sortByDateTime, eventsOG, eventNav, setEventNav, activeDate, setActiveDate, teamMembers, isEventManager } }/>
			</div>

			{(isOpen === "event" && indEvent) &&
				<div className={styles.fadeContainer}>
					<IndEvent { ... { indEvent, setIndEvent, handleOpen } }/>
				</div>
			}

			{(isOpen === "new" && !isEventManager) &&
				<NewEvent { ... { handleOpen, tempFormData } }/>
			}

			{(isOpen === "lockout" && !isEventManager) &&
				<Lockout { ... { handleOpen, tempFormData } }/>
			}
		</div>
	);
};

export default Hub;